module.exports = __webpack_public_path__ + "assets/images/cases/1.jpg";